import React from 'react';
import Page from '../../Page';
import type { SkinPageProps } from '../SkinPage';
import skinsStyles from './styles/NoMarginPageSkin.scss';
import type { BasePageSkinProps } from './BasePageSkin';
import BasePageSkin from './BasePageSkin';

const NoMarginPageSkin: React.FC<
  Omit<BasePageSkinProps, 'skinsStyle'>
> = props => <BasePageSkin {...props} skinsStyle={skinsStyles} />;

const NoMarginPage: React.FC<SkinPageProps> = props => (
  <Page {...props} skin={NoMarginPageSkin} />
);

export default NoMarginPage;
